module.exports = __webpack_public_path__ + "media/images/icons/material/share-boxed-f480b6dd400b0e252e95e9225e2ddf65.svg";